
import React, { useState } from "react";
import { Form, Row, Col, Button, Spinner, Modal } from 'react-bootstrap';
import config from 'react-global-configuration';
import axios from 'axios';
import toastr from "toastr";
import { cnpjMask, cpfMask } from '../../shared/mask';
import { validarCNPJ, validarCPF } from '../../shared/validators';
import * as XLSX from 'xlsx';

function NewReport({ onClose, onUpdate }) {

    const [docNumber, setDocNumber] = useState([]);
    const [docNumberErro, setDocNumberErro] = useState([]);
    const [load, setLoad] = useState(false);
    const [data, setData] = useState([]);
    const [anexos, setAnexos] = useState({}); // Objeto para armazenar anexos por índice do documento
    const [showAnexosModal, setShowAnexosModal] = useState(false);
    const [currentDocIndex, setCurrentDocIndex] = useState(null);

    const handleAddReport = () => {
        const docNumberVal = document.getElementById('docNumber').value.replace(/\D/g, '');
        if (docNumberVal !== '') {
            let isvalidDoc = false;
            if (docNumberVal.length === 11 && validarCPF(docNumberVal)) {
                isvalidDoc = true;
            } else if (docNumberVal.length === 14 && validarCNPJ(docNumberVal)) {
                isvalidDoc = true;
            }

            if (isvalidDoc) {
                setDocNumber((prev) => ([...prev, docNumberVal]));
                document.getElementById('docNumber').value = '';
            } else {
                toastr.error('O documento informado não é válido');
            }
        }
    }

    const onDelete = (index) => {
        setDocNumber((prev) => {
            prev.splice(index, 1);
            return [...prev];
        });
        // Remove também os anexos associados a este documento
        setAnexos((prev) => {
            const newAnexos = { ...prev };
            // Reorganiza os índices após remoção
            const reorganizedAnexos = {};
            Object.keys(newAnexos).forEach((key) => {
                const keyIndex = parseInt(key);
                if (keyIndex < index) {
                    reorganizedAnexos[keyIndex] = newAnexos[keyIndex];
                } else if (keyIndex > index) {
                    reorganizedAnexos[keyIndex - 1] = newAnexos[keyIndex];
                }
            });
            return reorganizedAnexos;
        });
    }

    const handleOpenAnexos = (index) => {
        setCurrentDocIndex(index);
        setShowAnexosModal(true);
    }

    const handleCloseAnexosModal = () => {
        setShowAnexosModal(false);
        setCurrentDocIndex(null);
    }

    const handleAddAnexo = (event) => {
        const file = event.target.files[0];
        if (file && currentDocIndex !== null) {
            const currentAnexos = anexos[currentDocIndex] || [];
            
            // Extensões de geolocation permitidas
            const geolocationExtensions = ['.geojson', '.kml', '.gpx', '.kmz', '.zip', '.json'];
            const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
            const isGeolocation = geolocationExtensions.includes(fileExtension);
            const isPDF = fileExtension === '.pdf';
            
            // Verificar se já existe arquivo de geolocation
            const hasGeolocation = currentAnexos.some(anexo => {
                const anexoExt = '.' + anexo.name.split('.').pop().toLowerCase();
                return geolocationExtensions.includes(anexoExt);
            });
            
            // Verificar quantidade de PDFs
            const pdfCount = currentAnexos.filter(anexo => {
                const anexoExt = '.' + anexo.name.split('.').pop().toLowerCase();
                return anexoExt === '.pdf';
            }).length;
            
            // Validações
            if (isGeolocation) {
                if (hasGeolocation) {
                    toastr.error('Já existe um arquivo de geolocation. É permitido apenas um arquivo de geolocation.');
                    event.target.value = null;
                    return;
                }
            } else if (isPDF) {
                if (pdfCount >= 5) {
                    toastr.error('É permitido no máximo 5 arquivos PDF.');
                    event.target.value = null;
                    return;
                }
                // Verificar tamanho do arquivo (5MB = 5 * 1024 * 1024 bytes)
                const maxSize = 5 * 1024 * 1024; // 5MB em bytes
                if (file.size > maxSize) {
                    toastr.error('O arquivo PDF deve ter no máximo 5MB.');
                    event.target.value = null;
                    return;
                }
            } else {
                toastr.error('É permitido somente arquivos de geolocation (.geojson, .kml, .gpx, .kmz, .zip, .json) ou PDFs.');
                event.target.value = null;
                return;
            }
            
            setAnexos((prev) => {
                const currentAnexos = prev[currentDocIndex] || [];
                return {
                    ...prev,
                    [currentDocIndex]: [...currentAnexos, { name: file.name, file: file }]
                };
            });
            event.target.value = null;
        }
    }

    const handleRemoveAnexo = (fileIndex) => {
        if (currentDocIndex !== null) {
            setAnexos((prev) => {
                const currentAnexos = prev[currentDocIndex] || [];
                currentAnexos.splice(fileIndex, 1);
                return {
                    ...prev,
                    [currentDocIndex]: [...currentAnexos]
                };
            });
        }
    }

    const getFileIcon = (fileName) => {
        const geolocationExtensions = ['.geojson', '.kml', '.gpx', '.kmz'];
        const fileExtension = '.' + fileName.split('.').pop().toLowerCase();
        
        if (fileExtension === '.pdf') {
            return <i className="bi bi-filetype-pdf"></i>;
        } else if (fileExtension === '.zip') {
            return <i className="bi bi-file-earmark-zip"></i>;
        } else if (fileExtension === '.json') {
            return <i class="bi bi-filetype-json"></i>;
        } else if (geolocationExtensions.includes(fileExtension)) {
            return <i className="bi bi-globe-americas"></i>;
        }
        return null;
    }

    const getNewProcessData = async (params) => {
        try {
            const url = config.get('urlbase') + '/processos/new';
            const userInfos = JSON.parse(localStorage.getItem('userInfos'));
            const headers = { 'x-api-key': userInfos.data.Token, 'Content-Type': 'application/json' };
            
            const response = (await axios.post(url, JSON.stringify(params), { headers: headers })).data;
            console.log(response);
        } catch (error) {
            console.log(error);
            toastr.error('Erro ao fazer uma nova busca de processos');
        }
    }

    const getSignedUrl = async (customercnpj, documento, dataRelatorio, fileName) => {
        try {
            const url = config.get('urlbase') + '/enrichments/rsac/upload-file';
            const userInfos = JSON.parse(localStorage.getItem('userInfos'));
            const headers = { 'x-api-key': userInfos.data.Token, 'Content-Type': 'application/json' };
            const params = {
                customercnpj: customercnpj,
                documento: documento,
                data_relatorio: dataRelatorio,
                file_name: fileName
            };
            
            const response = (await axios.post(url, JSON.stringify(params), { headers: headers })).data;
            if (response.Status === 'SUCCESS' && response.Item && response.Item.Url) {
                return { url: response.Item.Url, contentType: response.Item.ContentType };
            }
            throw new Error('Erro ao obter URL assinada');
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    const uploadFileToS3 = async (file, signedUrl, contentType) => {
        try {
            /* const response = await fetch(signedUrl, {
                method: 'PUT',
                body: file,
                headers: {
                    'Content-Type': file.type || 'application/octet-stream'
                }
            }); */
            // signedUrl = signedUrl.replace(`https://esgscan-reports-enriched-dev.s3.amazonaws.com`, `${document.location.origin}/uploadReports`);
            const userInfos = JSON.parse(localStorage.getItem('userInfos'));
            const response = await axios.put(signedUrl, file, { headers: { 'Content-Type': contentType || file.type || 'application/octet-stream', 'x-api-key': userInfos.data.Token, 'customercnpj': userInfos.data.customercnpj, 'contract_id': userInfos.data.contract_id, 'file_name': file.name } });
            
            if (!response.ok) {
                throw new Error(`Upload failed with status: ${response.status}`);
            }
            
            return true;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    const uploadAnexos = async (customercnpj, dataRelatorio) => {
        const uploadPromises = [];
        
        // Iterar sobre cada documento e seus anexos
        docNumber.forEach((documento, docIndex) => {
            const anexosDoDocumento = anexos[docIndex] || [];
            
            anexosDoDocumento.forEach((anexo) => {
                const uploadPromise = (async () => {
                    try {
                        // Obter URL assinada e ContentType
                        const { url: signedUrl, contentType } = await getSignedUrl(
                            customercnpj,
                            documento,
                            dataRelatorio,
                            anexo.name
                        );
                        
                        // Fazer upload do arquivo
                        await uploadFileToS3(anexo.file, signedUrl, contentType);
                        return { success: true, fileName: anexo.name };
                    } catch (error) {
                        //console.error(`Erro ao fazer upload do arquivo ${anexo.name}:`, error);
                        return { success: false, fileName: anexo.name, error: error.message };
                    }
                })();
                
                uploadPromises.push(uploadPromise);
            });
        });
        
        // Aguardar todos os uploads
        const results = await Promise.all(uploadPromises);
        
        // Verificar se houve erros
        const errors = results.filter(r => !r.success);
        if (errors.length > 0) {
            // console.error('Alguns arquivos falharam no upload:', errors);
            // Não lançar erro aqui, apenas logar, para não interromper o fluxo
        }
        
        return results;
    }

    const handleSubmit = async () => {
        setLoad(true);
        if (!docNumber || docNumber.length === 0) {
            setLoad(false);
            toastr.error('Por favor, adicione ao menos um documento válido');
            return;
        }
        try {
            const url = config.get('urlbase') + '/reports/v2/create-report';
            const userInfos = JSON.parse(localStorage.getItem('userInfos'));
            const headers = { 'x-api-key': userInfos.data.Token, 'Content-Type': 'application/json' };
            const params = {
                customercnpj: userInfos.data.customercnpj,
                documentos: docNumber
            };
            toastr.success('Aguarde! Estamos processando a sua solicitação');
            const response = (await axios.post(url, JSON.stringify(params), { headers: headers })).data;
            console.log(response);
            
            // Verificar se há anexos para fazer upload
            const hasAnexos = Object.keys(anexos).some(key => anexos[key] && anexos[key].length > 0);
            
            if (hasAnexos && response.Status === 'SUCCESS' && response.Item) {
                toastr.info('Enviando arquivos anexos...');
                try {
                    await uploadAnexos(userInfos.data.customercnpj, response.Item.data_relatorio);
                    toastr.success('Arquivos anexos enviados com sucesso');
                } catch (uploadError) {
                    console.error('Erro ao fazer upload dos anexos:', uploadError);
                    toastr.warning('Relatório criado, mas alguns arquivos anexos não puderam ser enviados');
                }
            }
            
            // for (let index = 0; index < docNumber.length; index++) {
            //     const newProcessparams = {
            //         customercnpj: userInfos.data.customercnpj,
            //         documento: docNumber[index],
            //         data_relatorio: response.Item.data_relatorio
            //     };
            //     getNewProcessData(newProcessparams);
            // }
            
            setDocNumber([]);
            setDocNumberErro([]);
            setAnexos({});
            toastr.success('Relatório solicitado com sucesso, em breve estará disponível na sua lista de relatórios');
            setTimeout(() => {
                onUpdate(true);
                onClose(true);
                setLoad(false);
            }, 2000);
        } catch (error) {
            console.log(error);
            setLoad(false);
            toastr.error('Erro ao fazer uma nova solicitação');
        }

    }

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            
            const reader = new FileReader();
    
            reader.onload = (e) => {
                setLoad(true);
                const binaryStr = e.target.result;
                const workbook = XLSX.read(binaryStr, { type: 'binary' });
                const firstSheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[firstSheetName];
                const jsonData = XLSX.utils.sheet_to_json(worksheet);
                let isvalidDoc = false;
                let countErr = 0;
                let formatErr = 0;
                jsonData.map((row) => {
                    if (row.Documento) {
                        isvalidDoc = false;
                        if (row.Documento.toString().replace(/[^\d]+/g, '').length === 11 && validarCPF(row.Documento.toString())) {
                            isvalidDoc = true;
                        } else if (row.Documento.toString().replace(/[^\d]+/g, '').length === 14 && validarCNPJ(row.Documento.toString())) {
                            isvalidDoc = true;
                        }

                        if (isvalidDoc) {
                            setDocNumber((prev) => ([...prev, row.Documento.toString().replace(/[^\d]+/g, '')]));
                        } else {
                            countErr++;
                            setDocNumberErro((prev) => ([...prev, row.Documento.toString().replace(/[^\d]+/g, '')]));
                        }
                    } else {
                        formatErr++;
                    }
                });
                if (countErr > 0) {
                    toastr.error('Existem números de documentos não válidos no arquivo');
                }
                if (formatErr > 0) {
                    toastr.error('O Formato do arquivo está incorreto, a planilha deve conter uma coluna com o nome "Documento" contendo os valores');
                }
                setLoad(false);
                event.target.value = null;
            };
            if (file) {
                reader.readAsBinaryString(file);
            }
        }
    };

    const handleClearInputFile = (event) => {
        document.getElementById('xlsUpload').value = null;
    }


    return (
        <>
            <Modal.Header closeButton>
                <Modal.Title>Novo Relatório</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row className="details-content" style={{ height: '350px' }}>
                    <Col md={6}>
                        <h5>Preencha os dados da solicitação</h5>
                        <Form.Group className='mt-3 mb-3'>
                            <Form.Label>Inclua o número do documento (CPF ou CNPJ) e clique em "Adicionar Documento"</Form.Label>
                            <Form.Control
                                type="text"
                                name="docNumber"
                                id="docNumber"
                            />
                        </Form.Group>
                        <a className='bt-new-report fs-6 mt-3' href='javascript:void(0);' onClick={handleAddReport}>Adicionar Documento <img className='ms-1' width='5%' src={process.env.PUBLIC_URL + '/static/imagens/bt-mais.png'} alt='Adicionar Documento' /></a>
                        <Form.Group className='mt-3'>
                            <Form.Label>Ou escolha um arquivo (.xls, .xlsx):</Form.Label>
                            <Form.Control
                                id="xlsUpload"
                                type="file"
                                label="Escolher Arquivo"
                                accept='.xlsx, .xls'
                                onChange={handleFileUpload}
                            />
                            <a href="javascript:void(0);" className="fs-6 pt-2" style={{textDecoration: 'none'}} onClick={handleClearInputFile}><i className="bi bi-trash fs-6"></i> limpar valor do campo</a>
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <h6 style={{ width: '50%' }}>Lista de documentos</h6>
                        <section className='scrollbar list-info mt-5' style={{ height: '250px' }}>
                            {docNumber.length > 0 && docNumber.map((item, index) => (
                                <div key={index} className={(index % 2) == 1 ? 'list-info-content even-content' : 'list-info-content odd-content'}>
                                    <span><b>Número do documento:</b><br /></span>
                                    <span>{item.length === 14 ? cnpjMask(item) : cpfMask(item)}</span>
                                    <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                                        <a href='javascript:;' className='link-primary' onClick={(e) => handleOpenAnexos(index)}>
                                            Adicionar / Ver anexos
                                        </a>
                                        <a href='javascript:;' className='link-danger' onClick={(e) => onDelete(index)}><i className="bi bi-trash fs-4"></i></a>
                                    </div>
                                </div>
                            ))}
                            
                            {docNumberErro.length > 0 && 
                                <>
                                    {docNumberErro.length > 0 && docNumber.length > 0 && <hr></hr> }
                                    <p className='text-danger mb-2'>Os erros encontrados abaixo serão ignorados na geração do relatório</p>
                                </>
                            }
                            {docNumberErro.length > 0 && docNumberErro.map((item, index) => (
                                <div key={index} className={(index % 2) == 1 ? 'list-info-content even-content' : 'list-info-content odd-content'}>
                                    <span><b>Número com erro:</b><br /></span>
                                    <span className='text-danger'>{item}</span>
                                </div>
                            ))}
                            {docNumber.length === 0 && <p className="mt-2">Nenhum documento válido adicionado</p>}

                        </section>
                        
                        
                        {docNumber.length > 0 && <p className="mt-2">Total de documentos válidos: <b>{docNumber.length}</b></p>}
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                {/* <Button className='small' variant="secondary" onClick={(e) => onClose(false)}>
                    Fechar
                </Button> */}
                {load ? <Spinner animation="border" variant="success" /> :
                    <Button className='small' variant="primary" onClick={handleSubmit}>
                        Gerar Relatório
                    </Button>
                }
            </Modal.Footer>

            {/* Modal de Anexos */}
            <Modal show={showAnexosModal} onHide={handleCloseAnexosModal} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>
                        Anexos - {currentDocIndex !== null && docNumber[currentDocIndex] 
                            ? (docNumber[currentDocIndex].length === 14 
                                ? cnpjMask(docNumber[currentDocIndex]) 
                                : cpfMask(docNumber[currentDocIndex]))
                            : ''}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="details-content">
                    <Form.Group className='mb-3'>
                        <p className='text-muted mb-2' style={{ fontSize: '0.9rem' }}>
                            É permitido somente um arquivo na extensão de geolocation e/ou 5 PDFs de até 5 mb.
                        </p>
                        <Form.Label>Adicionar arquivo:</Form.Label>
                        <Form.Control
                            type="file"
                            accept=".pdf,.geojson,.kml,.gpx,.kmz,.zip,.json"
                            onChange={handleAddAnexo}
                        />
                    </Form.Group>
                    <h6>Lista de anexos</h6>
                    <section className='scrollbar list-info mt-3' style={{ height: '300px' }}>
                        {currentDocIndex !== null && anexos[currentDocIndex] && anexos[currentDocIndex].length > 0 ? (
                            anexos[currentDocIndex].map((anexo, fileIndex) => (
                                <div key={fileIndex} className={(fileIndex % 2) == 1 ? 'list-info-content even-content' : 'list-info-content odd-content'}>
                                    {/* <span><b>Nome do arquivo:</b><br /></span> */}
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'space-between' }}>
                                        <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            {getFileIcon(anexo.name)}
                                            {anexo.name}
                                        </span>
                                        <a href='javascript:;' className='link-danger' onClick={(e) => handleRemoveAnexo(fileIndex)}>
                                            <i className="bi bi-trash fs-4"></i>
                                        </a>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <p className="mt-2">Nenhum anexo adicionado</p>
                        )}
                    </section>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseAnexosModal}>
                        Fechar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default NewReport;